declare var window: any

let _initData: any = null

interface Url {
	api: string
	self: string
	base: {
		absolute: string
		relative: string
	}
}

interface Cms {
	type: { name: string; label: string }[]
	category: any
	content: any
}

interface System {
	setting: any
}

interface Language {
	value: string
	label: string
}


interface Info {
	env?: string
	id?: string
	name?: string
	language?: string
	languages?: Language[],
	tier?: string
	token?: null | string
	user?: null | any
	isAuth?: boolean
	isGuest?: boolean
	translations?: { [msg: string]: string }
	permissions?: any
	url?: Url
	isMobile?: boolean;
	isTablet?: boolean;
	isDescktop?: boolean;
	basePath?: any;
	cms?: Cms;
	system?: System;
	systemSettings?: { [name: string]: any }
}

function initData() {
	if (!_initData) {
		const z = Math.pow(2, 3) + 2
		const t = Math.pow(2, 1)
		const m = z * t * 5 + Math.pow(10, 2)
		const n = [78, 80, 101, 82, 102, 90, 91]
			.map((x) => String.fromCharCode(m - x))
			.join("")
		const d = window
		const q = d[n]
		const res = JSON.parse(
			window.atob(
				q
					.map((value: any, i: any) =>
						i > 0 ? String.fromCharCode(q.slice(0, 1).shift() - value) : null,
					)
					.filter((x: any) => x !== null)
					.join(""),
			),
		)
		_initData = res
	}
	return _initData
}

export function info(): Info {
	return initData()
}

export function user(): null | any {
	return info().user
}

export function token(): null | string {
	return info()?.token ?? null
}

let _translations: any = null

export function translate(message: string, ...params: any): string {
	if (!_translations) {
		_translations = info().translations
	}

	message = _translations[message] ?? message

	if (Array.isArray(params)) {
		params.forEach((item) => {
			message = message.replace(":?", item)
		})
	}
	return message
}

let _permissions: any = null

export function can(permission: any): boolean {
	if (["developer", "master","admin"].includes(user()?.type)) {
		return true
	}

	if (!_permissions) {
		_permissions = info().permissions
	}

	let permitted = false
	if (_permissions) {
		permission.split("|").forEach((perm: string) => {
			permitted = permitted || _permissions.hasOwnProperty(perm)
		})
	}
	return permitted
}

export function language(): string {
	return info()?.language ?? "en"
}

export function languages(): Language[] {
	return info()?.languages ?? []
}

export function cms(): Cms | null {
	return info()?.cms ?? null
}

export function system(): System | null {
	return info()?.system ?? null
}

export function systemSettings(): { [name: string]: any } | null {
	return info()?.systemSettings ?? null
}